// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clip-circle[data-v-54a14ca0]{-webkit-clip-path:circle(80px at center);clip-path:circle(80px at center);width:260px;height:180px}@media (min-width:1024px){.clip-circle[data-v-54a14ca0]{-webkit-clip-path:circle(120px at center);clip-path:circle(120px at center);width:260px;height:300px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
